import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Signup() {
  const [credentials, setCredentials] = useState({
    name: "",
    email: "",
    password: "",
    phoneno: ""
  });
  let navigate = useNavigate();
  
  const handlesubmit = async (e) => {
    e.preventDefault();
    const nameError = document.getElementById("name-error")
    const emailError = document.getElementById("email-error")
    const passwordError = document.getElementById("password-error")
    const phonenoError = document.getElementById("phoneno-error")
    const { email, password, phoneno, name } = credentials;
    let Error;
    
    if (!name) {
      nameError.innerText = 'Please enter name'
      Error = true
    } else {
      nameError.innerText = ''
    }
    if (!email) {
      emailError.innerText = 'Please enter email'
      Error = true
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailError.innerText = 'Please enter a valid email address';
      Error = true;
    } else {
      emailError.innerText = ''
    }
    if (!phoneno) {
      phonenoError.innerText = 'Please enter number'
      Error = true
    } else if (!/^\d+$/.test(phoneno)) {
      phonenoError.innerText = 'Please enter a valid number';
      Error = true;
    } else {
      phonenoError.innerText = ''
    }
    if (!password) {
      passwordError.innerText = 'Please enter password'
      Error = true
    } else {
      passwordError.innerText = ''
    }
    if (Error) {
      return;
    }
    
    const res = await fetch("https://technic-mentors-backend.vercel.app/api/auth/signUp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password, name, phoneno }),
    });
    if (res.ok) {
      navigate("/user-login");
    }
  };
  
  const onchange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ backgroundColor: "#f1f6fe" }} className="background-img5">
      <div className="color-overlay5">
        <div className="allHeaderBg">
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
                Sign Up
              </h1>
            </div>
          </div>
        </div>
        
        <div className="container py-5">
          <div className="row align-items-center g-5">
            {/* Left Side - Content */}
            <div className="col-lg-6">
              <div className="pe-lg-4">
                <h2 className="display-5 fw-bold mb-4" style={{ color: "#1a237e" }}>
                  Join Our Innovation Journey
                </h2>
                <p className="lead mb-4" style={{ color: "#424242", lineHeight: "1.8" }}>
                  Transform your ideas into reality with cutting-edge software solutions. 
                  We're building the future of technology, one line of code at a time.
                </p>
                
                <div className="mb-4">
                  <div className="d-flex align-items-start mb-3">
                    <div className="me-3" style={{ 
                      width: "48px", 
                      height: "48px", 
                      borderRadius: "12px", 
                      backgroundColor: "#e3f2fd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="fas fa-code" style={{ color: "#1976d2", fontSize: "20px" }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#1a237e" }}>Expert Development</h5>
                      <p className="mb-0" style={{ color: "#616161" }}>
                        Access world-class development resources and expertise
                      </p>
                    </div>
                  </div>
                  
                  <div className="d-flex align-items-start mb-3">
                    <div className="me-3" style={{ 
                      width: "48px", 
                      height: "48px", 
                      borderRadius: "12px", 
                      backgroundColor: "#f3e5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="fas fa-rocket" style={{ color: "#7b1fa2", fontSize: "20px" }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#1a237e" }}>Fast Deployment</h5>
                      <p className="mb-0" style={{ color: "#616161" }}>
                        Accelerate your project timeline with agile methodologies
                      </p>
                    </div>
                  </div>
                  
                  <div className="d-flex align-items-start">
                    <div className="me-3" style={{ 
                      width: "48px", 
                      height: "48px", 
                      borderRadius: "12px", 
                      backgroundColor: "#e8f5e9",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="fas fa-shield-alt" style={{ color: "#388e3c", fontSize: "20px" }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#1a237e" }}>Secure & Reliable</h5>
                      <p className="mb-0" style={{ color: "#616161" }}>
                        Enterprise-grade security and 99.9% uptime guarantee
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="mt-4 p-4" style={{ 
                  backgroundColor: "white", 
                  borderRadius: "16px",
                  borderLeft: "4px solid #1976d2"
                }}>
                  <p className="mb-2" style={{ color: "#616161", fontSize: "14px" }}>
                    <i className="fas fa-quote-left me-2" style={{ color: "#1976d2" }}></i>
                    "Outstanding service and technical expertise. They transformed our business operations completely."
                  </p>
                  <p className="mb-0 fw-semibold" style={{ color: "#1a237e", fontSize: "14px" }}>
                    — Sarah Johnson, Tech Director
                  </p>
                </div>
              </div>
            </div>
            
            {/* Right Side - Form */}
            <div className="col-lg-6">
              <div className="p-4 p-lg-5" style={{ 
                backgroundColor: "white", 
                borderRadius: "20px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)"
              }}>
                <h3 className="mb-4 fw-bold" style={{ color: "#1a237e" }}>Create Your Account</h3>
                
                <form onSubmit={handlesubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label fw-semibold" style={{ color: "#424242" }}>
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      style={{ 
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0"
                      }}
                      name="name"
                      value={credentials.name}
                      onChange={onchange}
                      id="name"
                      placeholder="John Doe"
                    />
                    <div className="text-danger mt-1" id="name-error" style={{ fontSize: "14px" }}></div>
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label fw-semibold" style={{ color: "#424242" }}>
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      style={{ 
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0"
                      }}
                      name="email"
                      value={credentials.email}
                      onChange={onchange}
                      id="email"
                      placeholder="john@example.com"
                    />
                    <div className="text-danger mt-1" id="email-error" style={{ fontSize: "14px" }}></div>
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="phoneno" className="form-label fw-semibold" style={{ color: "#424242" }}>
                      Contact Number
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      style={{ 
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0"
                      }}
                      name="phoneno"
                      value={credentials.phoneno}
                      onChange={onchange}
                      id="phoneno"
                      placeholder="+1 234 567 8900"
                    />
                    <div className="text-danger mt-1" id="phoneno-error" style={{ fontSize: "14px" }}></div>
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="password" className="form-label fw-semibold" style={{ color: "#424242" }}>
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      style={{ 
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0"
                      }}
                      name="password"
                      value={credentials.password}
                      onChange={onchange}
                      id="password"
                      placeholder="••••••••"
                    />
                    <div className="text-danger mt-1" id="password-error" style={{ fontSize: "14px" }}></div>
                  </div>
                  
                  <button
                    type="submit"
                    className="btn w-100 py-3 fw-semibold"
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      borderRadius: "10px",
                      border: "none",
                      fontSize: "16px",
                      transition: "all 0.3s"
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#684df4"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "#684df4"}
                  >
                    Create Account
                    <i className="fas fa-arrow-right ms-2"></i>
                  </button>
                </form>
                
                <p className="text-center mt-4 mb-0" style={{ color: "#616161" }}>
                  Already have an account?{" "}
                  <Link to="/user-login" style={{ 
                    color: "#684df4", 
                    textDecoration: "none",
                    fontWeight: "600"
                  }}>
                    Sign In
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}